var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-vip-header"},[(_vm.videoUrl)?_c('videoPlayer',{attrs:{"videoSrc":_vm.videoUrl,"poster":_vm.posterSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }